import {AesRsaEncryptedData} from "@qid/crypto";
import {Account} from "../../../interface/account.interface";
import {DocumentData} from "../../id";
import {ID} from "../../../models/ID";

export class CreateDocumentAccessDto {

  grantedToAccount?: Account;

  documentOwnerAccount?: Account;

  document: ID;

  aesRsaEncryptedData: AesRsaEncryptedData;

  documentData: DocumentData;

}
